import React, { ElementType, FC } from 'react';
import Tooltip from 'react-tooltip';
import styles from './filter_item.module.scss';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';

export type FilterType = {
  icon?: ElementType;
  label?: string;
  labelFull?: string;
  title?: string;
  subTitle?: string;
  handleRemove?: () => void;
};

type Props = {
  filter: FilterType;
};

export const FilterItem: FC<Props> = ({
  filter: {
    label,
    labelFull,
    title,
    subTitle,
    handleRemove = undefined,
    icon: Icon,
  },
}) => {
  return (
    <span className={styles.container} data-for={labelFull} data-tip>
      {Icon && <Icon className={styles.entityIcon} />}
      {label && <span className={styles.label}>{label}</span>}
      {title && subTitle && (
        <div className={styles.bigLabelContainer}>
          <span className={styles.title}>{title}</span>
          <span className={styles.subTitle}>{subTitle}</span>
        </div>
      )}
      {handleRemove && (
        <button className={styles.button} onClick={handleRemove} type="button">
          <MaterialIcon name="clear" className={styles.removeIcon} />
        </button>
      )}
      {labelFull && (
        <Tooltip effect="solid" id={labelFull}>
          {labelFull}
        </Tooltip>
      )}
    </span>
  );
};
